// Pure helpers — no API changes. A lead is "missed" if it's still status:"new"
// AND was created more than 2 hours ago. Visual indicator only — never written.

export const MISSED_THRESHOLD_MS = 2 * 60 * 60 * 1000; // 2 hours

export const isMissedLead = (lead) => {
  if (!lead) return false;
  if (lead.status !== "new") return false;
  if (!lead.created_at) return false;
  const ageMs = Date.now() - new Date(lead.created_at).getTime();
  return ageMs > MISSED_THRESHOLD_MS;
};

export const countMissedLeads = (leads) =>
  Array.isArray(leads) ? leads.filter(isMissedLead).length : 0;

export const formatMissedDuration = (lead) => {
  if (!lead?.created_at) return "";
  const ageMs = Date.now() - new Date(lead.created_at).getTime();
  const hours = Math.floor(ageMs / (60 * 60 * 1000));
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return `${days} day${days === 1 ? "" : "s"}`;
  }
  return `${hours} hour${hours === 1 ? "" : "s"}`;
};
